import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  updateRole(event) {
    const checkbox = event.target
    const roleId = checkbox.dataset.roleId
    const permissionId = checkbox.value
    const checked = checkbox.checked

    fetch("/role-permissions", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        role_id: roleId,
        permission_id: permissionId,
        assigned: checked,
      }),
    })
        .then(response => {
          if (!response.ok) throw new Error("Network response was not ok")
          else {
            this.dispatch("notify", { detail: { message: "The permission was successfully updated!" } })
          }
        })
        .catch(error => {
          console.error("Error:", error)
          checkbox.checked = !checked // Revert checkbox if request fails
          this.dispatch("notify", { detail: { message: "Failed to update permission. Please try again!" } })
        })
  }
}